import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';
import { useTranslations } from "examsbook-react-sdk/custom-hooks";
import { PieChart, Pie, Tooltip, Cell } from 'recharts';
import './reports.scss';

function ChartComponent({ title, data, COLORS }) {
    const t = useTranslations();

    const legendData = data.map((entry, index) => ({
        name: entry.name,
        color: COLORS[index % COLORS.length],
    }));

    const renderTooltip = ({ payload }) => {
        if (payload?.length === 1) {
            const { value } = payload[0];
            const percentage = value;

            return (
                <div className="custom-tooltip">
                    <p>{`${percentage.toFixed(2)}`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <Box className="graph-box-container">
            <Box className='title-heading'>{t(title)}</Box>
            <Box className="legends-right">
                <PieChart width={250} height={190} className='chart-data'>
                    <Pie
                        dataKey="value"
                        data={data}
                        cx={130}
                        cy={90}
                        innerRadius={55}
                        outerRadius={90}
                        fill="#8884d8"
                    >
                        {data.map((entry, index) => (
                            <Cell key={`cell-${entry.name}`} fill={COLORS[index % COLORS.length]} />
                        ))}
                    </Pie>
                    <Tooltip content={renderTooltip} />
                </PieChart>
                <Box className="legend">
                    {legendData.map((entry) => (
                        <div key={`legend-${entry.name}`} className="legend-item">
                            <div className="legend-circle" style={{ backgroundColor: entry.color }}></div>
                            <p>{t(entry.name)}</p>
                        </div>
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

ChartComponent.propTypes = {
    title: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        })
    ),
    COLORS: PropTypes.arrayOf(PropTypes.string),
};

function QuestionDistribution({ courseResultData, activeKey }) {

    const data = [
        { name: 'Correct_Answer', value: courseResultData?.correctAnswerArray?.[activeKey] },
        { name: 'Unanswered', value: courseResultData?.attemptsField?.[activeKey]?.unAnsweredQuestion },
        { name: 'incorrect_answer', value: courseResultData?.incorrectAnswerArray?.[activeKey] },
    ];

    const COLORS = ['#698192', '#0C3450', '#3D5D73'];

    return <ChartComponent title="question_distribution" data={data} COLORS={COLORS} />;
}

QuestionDistribution.propTypes = {
    activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    courseResultData: PropTypes.shape({
        correctAnswerArray: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        incorrectAnswerArray: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
        attemptsField: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    }),
};

function TimeSpent({ courseResultData, activeKey }) {
    let timeTaken = (courseResultData?.attemptsField?.[activeKey]?.timeSpent)?.toFixed(2)
    let newTime = timeTaken/60

    const data = [
        { name: 'total_time', value: courseResultData?.duration},
        { name: 'time_taken', value: newTime},
    ];

    const COLORS = ['#698192', '#0C3450'];

    return <ChartComponent title='time_spent' data={data} COLORS={COLORS} />;
}

TimeSpent.propTypes = {
    activeKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    courseResultData: PropTypes.shape({
        duration: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        attemptsField: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    }),
};

export { QuestionDistribution, TimeSpent };
